import styled from 'styled-components';

const StyledAnnotationOptionPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px 10px;
  border-bottom: 1px solid var(--theme-overlay-divider, #eef0f4);
  box-sizing: border-box;
`;

const StyledAnnotationOptionPanelHeaderTitle = styled.h3`
  margin: 0;
  flex: 1 1 auto;
  min-width: 0;
  font-family: Poppins, system-ui, sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--theme-overlay-text, var(--primary-text-color, #1f2a44));
`;

const StyledAnnotationOptionPanelHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

const StyledAnnotationOptionPanelHeaderReset = styled.button`
  margin: 0;
  padding: 4px 8px;
  border: none;
  border-radius: 6px;
  background: transparent;
  font-family: Poppins, system-ui, sans-serif;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--accent-primary-active, #f8558e);
  cursor: pointer;

  &:hover {
    background: var(--theme-overlay-hover, #fff5f9);
  }
`;

export {
  StyledAnnotationOptionPanelHeader,
  StyledAnnotationOptionPanelHeaderTitle,
  StyledAnnotationOptionPanelHeaderActions,
  StyledAnnotationOptionPanelHeaderReset,
};
